(function($) {


    $('.share .copytoclipboard').off('click').on('click', function(e) {

        e.preventDefault();

        var textToCopy = $('.share .copytoclipboard #inputCopy').text();
        var tempTextarea = $('<textarea>');
        $('body').append(tempTextarea);
        tempTextarea.val(textToCopy).select();
        document.execCommand('copy');
        tempTextarea.remove();

        $('.share .copytoclipboard .copylink').hide();
        $('.share .copytoclipboard .copycheck').show();

        setTimeout(function() {
            $('.share .copytoclipboard .copycheck').hide();
            $('.share .copytoclipboard .copylink').show();
        }, 2000);

    });

})(jQuery);